const state = {
    dns_data: [],
    dns_enabled: "",
    dns_serial: "",
    dns_operation_in_progress: "",
    has_changes: false,
};

const getters = {

};

const actions = {
   LoadDns({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('get_dns', {
                domain_id: request_data['domain_id'],
            });

            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        let data = response.data.data,
                            dns_data = [];

                        for(let i = 0; i < data.dns_data.length; i++)
                        {
                            let new_entry = {...data.dns_data[i], data_index:i};
                            dns_data.push(new_entry);
                        }

                        commit("setDnsData", dns_data);
                        commit("setDnsEnabled", data.dns_enabled);
                        commit("setDnsSerial", data.dns_serial);
                        commit("setDnsOperation", data.dns_operation_in_progress);

                        resolve(data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    PostDnsData({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('post_dns', {
                domain_id: request_data['dns_data']['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
};

const mutations = {
    setDnsData(state, value){
        state.dns_data = value;
    },

    setDnsEnabled(state, value){
        state.dns_enabled = parseInt(value);
    },

    setDnsSerial(state, value){
        state.dns_serial = parseInt(value);
    },

    setDnsOperation(state, value){
        state.dns_operation_in_progress = parseInt(value);
    },

    setHasChanges(state, value){
        state.has_changes = value;
    },

    addDnsRecord(state, record){
        let max_index = -1;
        for(let i = 0; i < state.dns_data.length; i++)
        {
            if(state.dns_data[i].data_index > max_index)
            {
                max_index = state.dns_data[i].data_index;
            }
        }

        record.data_index = ++max_index;
        state.dns_data.push(record);

        state.has_changes = true;
    },

    saveDnsRecord(state, record){
        let record_index = record.data_index;

        for(let i = 0; i < state.dns_data.length; i++)
        {
            if(state.dns_data[i].data_index === record_index)
            {
                this._vm.$set(state.dns_data, i, JSON.parse(JSON.stringify(record)));
                break;
            }
        }

        state.has_changes = true;
    },

    deleteDnsRecord(state, record_index){
        for(let i = 0; i < state.dns_data.length; i++)
        {
            if(state.dns_data[i].data_index === record_index)
            {
                this._vm.$delete(state.dns_data, i);
                break;
            }
        }

        state.has_changes = true;
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
